/** Image helper — paths resolve from /public/subdomains/<slug>/ */
export const subdomainImage = (slug, filename) => `/subdomains/${slug}/${filename}`;
